module.exports = __webpack_public_path__ + "img/Katarina_home_13.3584dc98.jpg";